// extracted by mini-css-extract-plugin
export var blue = "_1p-g";
export var brand = "_1p-c";
export var darkGrey = "_1p-f";
export var disabled = "_1p-6";
export var disabledSubtle = "_1p-7";
export var error = "_1p-8";
export var green = "_1p-h";
export var grey = "_1p-e";
export var icon = "_1p-0";
export var inherit = "_1p-b";
export var lightGrey = "_1p-d";
export var orange = "_1p-j";
export var pink = "_1p-l";
export var primary = "_1p-1";
export var purple = "_1p-m";
export var quaternary = "_1p-4";
export var quinary = "_1p-5";
export var red = "_1p-k";
export var secondary = "_1p-2";
export var success = "_1p-a";
export var tertiary = "_1p-3";
export var warning = "_1p-9";
export var white = "_1p-n";
export var yellow = "_1p-i";